module.exports = __webpack_public_path__ + "img/组 7.14254a41.png";